import { render, staticRenderFns } from "./CarList.vue?vue&type=template&id=b28b1030&scoped=true&"
import script from "./CarList.vue?vue&type=script&lang=js&"
export * from "./CarList.vue?vue&type=script&lang=js&"
import style0 from "./CarList.vue?vue&type=style&index=0&id=b28b1030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28b1030",
  null
  
)

export default component.exports